import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/ibs-2023-selections")({
  beforeLoad: () => {
    throw redirect({ to: "/demo/photoreal-selections", statusCode: 301 });
  },
});
